import React from 'react';
import PropTypes from 'prop-types';

const ClaimInfo = ({ claimnumber, calculationtime, filename }) => {



  return (
    <div className="calc-div-inline calc-div-inline-space">
      {claimnumber && <span className="calc-info-tag"  style={{background : '#06156d'}} >Kröfunúmer : {claimnumber}</span>}
      {filename && <span className="calc-info-tag"  style={{background : '#06156d'}} >Skrá : {filename}</span>}
      {calculationtime && <span className="calc-info-tag"  style={{background : '#06156d'}} >Útreikningstími : {calculationtime.toString()} ms</span>}
    </div>
  );
};

ClaimInfo.propTypes = {
  claimnumber: PropTypes.string,
  calculationtime: PropTypes.number,
  filename: PropTypes.string,
};

export default ClaimInfo;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Tags/ClaimInfo.js